import { connect } from 'react-redux';
import { hideOnboarding } from 'actions/Onboarding';
import { mediaSelectors, callActions } from '@lifesize/nucleus';
import OnboardingComp from 'components/Onboarding/Onboarding';
import _get from 'lodash/get';

const mapStateToProps = state => ({
  videoDevices: mediaSelectors.videoDevices(state),
  audioDevices: mediaSelectors.audioDevices(state),
  showOnboarding: _get(state, 'app.onboarding.isOnboarding')
});

const mapDispatchToProps = dispatch => ({
  toggleDoNotDisturb: (value) => {
    dispatch(callActions.toggleDoNotDisturb(value));
  },
  hideOnboarding: () => dispatch(hideOnboarding())
});

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingComp);
